import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import SocialLogin from './SocialLogin';

interface LoginModalProps {
    isOpen: boolean;
    onClose: () => void;
    onContinueAsGuest?: () => void;
}

export default function LoginModal({ isOpen, onClose, onContinueAsGuest }: LoginModalProps) {
    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[200] flex items-center justify-center p-6">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="absolute inset-0 bg-game-bg/80 backdrop-blur-md"
                    />

                    <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        className="relative w-full max-w-md glass-card p-10 border-game-primary/30"
                    >
                        <button
                            onClick={onClose}
                            className="absolute top-4 right-4 text-2xl text-game-muted hover:text-game-text"
                        >
                            ✕
                        </button>

                        <div className="text-center mb-8">
                            <div className="text-5xl mb-6">🔒</div>
                            <h2 className="text-3xl font-heading font-black mb-2 uppercase italic tracking-tight">Sync Progress</h2>
                            <div className="space-y-3 text-game-muted">
                                <p>You need to join the server to save your XP, earn badges, and track your levels.</p>
                                <p className="text-sm">
                                    Curious how XP, lives, and streaks work?{' '}
                                    <Link to="/game-guide" className="text-game-primary-l font-semibold" onClick={onClose}>
                                        Read the Game Guide →
                                    </Link>
                                </p>
                            </div>
                        </div>

                        <SocialLogin />

                        <button
                            onClick={onContinueAsGuest || onClose}
                            className="mt-6 w-full py-3 text-xs font-mono text-game-dim uppercase tracking-widest hover:text-game-text transition-colors"
                        >
                            Continue as Guest
                            <span className="block text-[0.6rem] font-normal text-game-muted tracking-normal">Progress resets after session</span>
                        </button>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
}
